import { model as routerModel } from '!/router'
import type { PurchaseInfo } from '@setplex/tria-api'
import { combine, createEvent, sample, type Store } from 'effector'
import { COMPONENT, register } from '!/repository'
import { siginInToWatchFeatureModel } from '~/features/signin-to-watch'
import { model as guestModel } from '~/features/subscriber/guest'
import { aye } from '~/shared/helpers'
import { $signInToWatchTranslations } from './translations'
import { DescriptionWithLink } from './DescriptionWithLink'

interface SignInToWatchItem {
  id?: number
  name?: string
  free?: boolean
  purchaseInfo?: PurchaseInfo
}

export const genSignInToWatchLogic = (
  entityStore: Store<SignInToWatchItem | null>,
  redirect: Store<string | null>
) => {
  const openPlayerSignInToWatchPopup = createEvent<void>()

  sample({
    clock: openPlayerSignInToWatchPopup,
    source: {
      entity: entityStore,
      redirect: redirect,
    },
    filter: ({ entity }) => aye(entity),
    fn: ({ entity, redirect }) => {
      const { name } = entity!

      return {
        name: name ?? '',
        redirect: redirect ?? '',
      }
    },
    target: siginInToWatchFeatureModel.openSignInToWatchPopup,
  })

  const $showSignInToWatchPopup = combine(
    {
      guest: guestModel.$guest,
      entity: entityStore,
      query: routerModel.$query,
    },
    ({ guest, entity, query }) => {
      if (!entity) return null
      const trailer = query.get('trailer')

      return aye(guest) && !entity.free && !entity.purchaseInfo && !trailer
    }
  )

  return {
    $showSignInToWatchPopup,
    openPlayerSignInToWatchPopup,
  }
}

register(
  $signInToWatchTranslations,
  '$signInToWatchPopupWidget/signInToWatchTranslations'
)

register(
  siginInToWatchFeatureModel.$signInToWatchItem,
  '$siginInToWatchFeature/signInToWatchItem'
)
register(
  siginInToWatchFeatureModel.signInToWatch,
  'siginInToWatchFeature/signInToWatch'
)
register(
  siginInToWatchFeatureModel.openSignInToWatchPopup,
  'siginInToWatchFeature/openSignInToWatchPopup'
)
register(
  siginInToWatchFeatureModel.closeSignInToWatchPopup,
  'siginInToWatchFeature/closeSignInToWatchPopup'
)
register(DescriptionWithLink, 'DescriptionWithLink', COMPONENT)
